module.exports = __webpack_public_path__ + "img/4-4.5af79ca7.png";